import React, { useState, useEffect } from "react";
import { MdDelete } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { tableCellClasses } from "@mui/material/TableCell";
import s from "./newAdminTransaction.module.css";
import { useNavigate } from "react-router-dom";
import {
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    Pagination,
} from "@mui/material";
import { notificationHandler } from "../../utils/Notification";
import Loder from "../../Loder/Loder";
import { BiFilter, BiSearch } from "react-icons/bi";
import DataNotFound from "../ErrorPage/DataNotFound";
import { IoMdAdd } from "react-icons/io";
import { getadiminTransaction_api } from "../api/adminTransaction";
import xlsx from "json-as-xlsx";
import { toast } from "react-toastify";
import TablePaginationDemo from "../../Common/CustomPageData";
import Cookies from "js-cookie";
import { getBaseUrl, getBaseUrl2 } from "../../utils";
import UploadNewTransactionVideoUrl from "./UploadNewTransactionVideo";
import { FaSpinner } from "react-icons/fa";

const NewTransactionList = () => {
    const navigate = useNavigate();
    const [isLoading, setisLoading] = useState(false);
    const [adminTransactions, setAdminTransactions] = useState([]);
    const [pageCount, setpageCount] = useState(1);
    const [deleteId, setdeleteId] = useState("");
    const [deletePopup, setdeletePopup] = useState(false);
    const [currentTransaction, setCurrentTransaction] = useState({});
    const [pageLength, setpageLength] = useState();
    const [search, setsearch] = useState("");
    const [uploadVideoModal, setuploadVideoModal] = useState(false);
    const [transactionId, settransactionId] = useState("");
    const [statusFilter, setstatusFilter] = useState();
    const [startDate, setstartDate] = useState("");
    const [endDate, setendDate] = useState("");
    const [totalData, setTotalData] = useState("");
    const [limit, setLimit] = useState(10);
    const [userId, setuserId] = useState("");
    const [typeForPopUp, setTypeForPopUp] = useState("");
    const [isExportingLoading, setIsExportingLoading] = useState(false);

    useEffect(() => {
        fetchAdminTransactionsFunc();
    }, [pageCount, search, startDate, endDate, limit, statusFilter]);

    async function fetchAdminTransactionsFunc() {
        setisLoading(true);
        try {
            const temp = {
                page: pageCount,
                limit: limit,
                search: search.trim(),
                startDate: startDate,
                endDate: endDate,
                status: statusFilter,
            };
            let res = await fetch(`${getBaseUrl()}admin/getAllPujaTransaction?page=${temp.page}&limit=${temp.limit}&search=${temp.search}&startDate=${temp?.startDate || ""
                }&endDate=${temp?.endDate || ""}&status=${temp?.status}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${Cookies.get("token")}`,
                },
            });
            res = await res.json();
            if (res.status) {
                setAdminTransactions(res?.data || []);
                setpageLength(res?.meta?.totalPages);
                setTotalData(res?.meta?.totalTransactions);
                setisLoading(false);
            } else {
                setisLoading(false);
                console.log("status false!");
            }
        } catch (error) {
            console.log(error);
        }
    }

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: "var(--clr-theme)",
            color: theme.palette.common.white,
            fontWeight: "bold",
            borderRight: "1px solid #fff",
            overflow: "hidden",
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
            border: "none",
            borderLeft: "2px solid #00000011",
            "&:last-child": {
                borderRight: "2px solid #00000011",
            },
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        borderBottom: "2px solid #00000011",
    }));

    //  This is used to export the data in the excel file

   let settings = {
  fileName: "Transaction_List",
  extraLength: 3,
  writeMode: "writeFile",
  writeOptions: {},
};
// const exportTransactionFunc = (adminTransactions) => {
//   setIsExportingLoading(true);

//   if (!adminTransactions || adminTransactions.length < 1) {
//     setIsExportingLoading(false);
//     return toast.alert("No Data available for export");
//   }

//   const dash = "—";
//   const safe = (v) => (v !== null && v !== undefined && v !== "" ? v : dash);
//   const dateOnly = (d) => (d ? String(d).slice(0, 10) : dash);

//   let data = [
//     {
//       sheet: "Transactions Data",
//       columns: [
//         /* ================= BASIC TRANSACTION ================= */
//         { label: "Custom Order ID", value: (r) => safe(r?.customOrderId) },
//         { label: "Order ID", value: (r) => safe(r?.orderId) },
//         { label: "Payment ID", value: (r) => safe(r?.paymentId) },
//         { label: "Status", value: (r) => safe(r?.status) },
//         { label: "Delivery Status", value: (r) => safe(r?.deliveryStatus) },
//         { label: "Transaction By", value: (r) => safe(r?.transaction_by) },
//         { label: "Mode", value: (r) => safe(r?.mode) },

//         { label: "Created Date", value: (r) => dateOnly(r?.created_at) },
//         { label: "Updated Date", value: (r) => dateOnly(r?.updated_at) },

//         /* ================= AMOUNT ================= */
//         { label: "Amount Paid", value: (r) => safe(r?.amount) },
//         { label: "Puja Amount", value: (r) => safe(r?.pujaAmount) },
//         { label: "Currency", value: (r) => safe(r?.currency) },

//         /* ================= USER ================= */
//         { label: "User ID", value: (r) => safe(r?.userId?._id) },
//         { label: "User Name", value: (r) => safe(r?.userId?.name) },
//         { label: "User Phone", value: (r) => safe(r?.userId?.phone) },

//         /* ================= EVENT / PUJA ================= */
//         { label: "Event ID", value: (r) => safe(r?.eventId?._id) },
//         { label: "Event Name", value: (r) => safe(r?.eventId?.name) },
//         { label: "Event Hindi Title", value: (r) => safe(r?.eventId?.titleHindi) },
//         { label: "Primary God Name", value: (r) => safe(r?.eventId?.primaryGodName) },
//         { label: "Purpose", value: (r) => safe(r?.eventId?.purpose) },
//         { label: "Event Price", value: (r) => safe(r?.eventId?.price) },
//         { label: "Event Date", value: (r) => dateOnly(r?.eventId?.date) },
//         { label: "Puja Date", value: (r) => dateOnly(r?.pujaDate) },

//         /* ================= EXTRA SERVICES ================= */
//         {
//           label: "No. of Members",
//           value: (r) => safe(r?.extraServices?.numberOfMembers?.title),
//         },
//         {
//           label: "Members Price",
//           value: (r) => safe(r?.extraServices?.numberOfMembers?.price),
//         },
//         {
//           label: "Prasad Home Delivery",
//           value: (r) => safe(r?.extraServices?.prasadHomeDelivery?.title),
//         },
//         {
//           label: "Prasad Delivery Price",
//           value: (r) => safe(r?.extraServices?.prasadHomeDelivery?.price),
//         },

//         /* ================= SHIPPING ================= */
//         { label: "Shipping Name", value: (r) => safe(r?.shippingDetails?.name) },
//         { label: "Shipping Mobile", value: (r) => safe(r?.shippingDetails?.mobileNumber) },
//         {
//           label: "Shipping Alternate Mobile",
//           value: (r) => safe(r?.shippingDetails?.alternateNumber),
//         },
//         { label: "Shipping Address", value: (r) => safe(r?.shippingDetails?.address) },
//         { label: "Shipping City", value: (r) => safe(r?.shippingDetails?.city) },
//         { label: "Shipping State", value: (r) => safe(r?.shippingDetails?.state) },
//         { label: "Shipping Country", value: (r) => safe(r?.shippingDetails?.country) },
//         { label: "Shipping Pincode", value: (r) => safe(r?.shippingDetails?.pincode) },

//         /* ================= MEDIA / CERTIFICATE ================= */
//         { label: "Video URL", value: (r) => safe(r?.videoUrl) },
//         { label: "Certificate Path", value: (r) => safe(r?.certificate?.path) },
//         {
//           label: "Certificate Issued At",
//           value: (r) => dateOnly(r?.certificate?.issuedAt),
//         },

//         /* ================= FLAGS ================= */
//         {
//           label: "Reminder Sent",
//           value: (r) => (r?.reminderSent ? "Yes" : "No"),
//         },
//       ],
//       content: adminTransactions,
//     },
//   ];

//   let callback = function (sheet) {
//     console.log("Excel Download Complete:", sheet);
//     setIsExportingLoading(false);
//   };

//   try {
//     xlsx(data, settings, callback);
//   } catch (error) {
//     console.error(error);
//     setIsExportingLoading(false);
//   }
// };
// const exportTransactionFunc = async () => {
//   setIsExportingLoading(true);
//   try {
//     const url = `${getBaseUrl
//         ()}admin/pujaTransactions/export?startDate=${startDate || ""}&endDate=${endDate || ""}`;
//     let res = await fetch(url, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${Cookies.get("token")}`,
//       },
//     });
//     res = await res.json();
//     if (!res?.status || !res?.data || res?.data.length < 1) {
//       setIsExportingLoading(false);
//       return toast.alert("No data available for export");
//     }
//     const adminTransactions = res.data;
//     /* ================= EXCEL LOGIC ================= */

//     const dash = "—";
//     const safe = (v) => (v !== null && v !== undefined && v !== "" ? v : dash);
//     const dateOnly = (d) => (d ? String(d).slice(0, 10) : dash);

//     let data = [
//       {
//         sheet: "Transactions Data",
//         columns: [
//           { label: "Custom Order ID", value: (r) => safe(r?.customOrderId) },
//           { label: "Order ID", value: (r) => safe(r?.orderId) },
//           { label: "Payment ID", value: (r) => safe(r?.paymentId) },
//           { label: "Status", value: (r) => safe(r?.status) },
//           { label: "Delivery Status", value: (r) => safe(r?.deliveryStatus) },
//           { label: "Transaction By", value: (r) => safe(r?.transaction_by) },
//           { label: "Mode", value: (r) => safe(r?.mode) },

//           { label: "Created Date", value: (r) => dateOnly(r?.created_at) },
//           { label: "Updated Date", value: (r) => dateOnly(r?.updated_at) },

//           { label: "Amount Paid", value: (r) => safe(r?.amount) },
//           { label: "Puja Amount", value: (r) => safe(r?.pujaAmount) },
//           { label: "Currency", value: (r) => safe(r?.currency) },

//           { label: "User ID", value: (r) => safe(r?.userId?._id) },
//           { label: "User Name", value: (r) => safe(r?.userId?.name) },
//           { label: "User Phone", value: (r) => safe(r?.userId?.phone) },

//           { label: "Event ID", value: (r) => safe(r?.eventId?._id) },
//           { label: "Event Name", value: (r) => safe(r?.eventId?.name) },
//           { label: "Event Hindi Title", value: (r) => safe(r?.eventId?.titleHindi) },
//           { label: "Primary God Name", value: (r) => safe(r?.eventId?.primaryGodName) },
//           { label: "Purpose", value: (r) => safe(r?.eventId?.purpose) },
//           { label: "Event Price", value: (r) => safe(r?.eventId?.price) },
//           { label: "Event Date", value: (r) => dateOnly(r?.eventId?.date) },
//           { label: "Puja Date", value: (r) => dateOnly(r?.pujaDate) },

//           { label: "No. of Members", value: (r) => safe(r?.extraServices?.numberOfMembers?.title) },
//           { label: "Members Price", value: (r) => safe(r?.extraServices?.numberOfMembers?.price) },
//           { label: "Prasad Home Delivery", value: (r) => safe(r?.extraServices?.prasadHomeDelivery?.title) },
//           { label: "Prasad Delivery Price", value: (r) => safe(r?.extraServices?.prasadHomeDelivery?.price) },

//           { label: "Shipping Name", value: (r) => safe(r?.shippingDetails?.name) },
//           { label: "Shipping Mobile", value: (r) => safe(r?.shippingDetails?.mobileNumber) },
//           { label: "Shipping Alternate Mobile", value: (r) => safe(r?.shippingDetails?.alternateNumber) },
//           { label: "Shipping Address", value: (r) => safe(r?.shippingDetails?.address) },
//           { label: "Shipping City", value: (r) => safe(r?.shippingDetails?.city) },
//           { label: "Shipping State", value: (r) => safe(r?.shippingDetails?.state) },
//           { label: "Shipping Country", value: (r) => safe(r?.shippingDetails?.country) },
//           { label: "Shipping Pincode", value: (r) => safe(r?.shippingDetails?.pincode) },

//           { label: "Video URL", value: (r) => safe(r?.videoUrl) },
//           { label: "Certificate Path", value: (r) => safe(r?.certificate?.path) },
//           { label: "Certificate Issued At", value: (r) => dateOnly(r?.certificate?.issuedAt) },

//           { label: "Reminder Sent", value: (r) => (r?.reminderSent ? "Yes" : "No") },
//         ],
//         content: adminTransactions,
//       },
//     ];

//     xlsx(data, settings, () => {
//       console.log("Excel Export Done");
//       setIsExportingLoading(false);
//     });
//   } catch (error) {
//     console.error(error);
//     toast.error("Export failed");
//     setIsExportingLoading(false);
//   }
// };

//  this code is used to direct download the excel sheet
const exportTransactionFunc = async () => {
  setIsExportingLoading(true);
  try {
    const url = `${getBaseUrl()}admin/pujaTransactions/export?startDate=${startDate || ""}&endDate=${endDate || ""}`;

    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${Cookies.get("token")}`,
      },
    });

    if (!res.ok) {
      throw new Error("Download failed");
    }

    // 👇 IMPORTANT
    const blob = await res.blob();

    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = `puja-transactions-${Date.now()}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(downloadUrl);
    setIsExportingLoading(false);
  } catch (error) {
    console.error(error);
    toast.error("Export failed");
    setIsExportingLoading(false);
  }
};
    return (
        <div className="">
            <div className="beat_heading">
                <div className={s["user-list-heading"]}>
                    <div className="user-list-title">
                        <h3>Transaction List</h3>
                    </div>
                    <div className={s["user-list-search"]}>
                        <div className={s["search-box"]}>
                            <span style={{ paddingRight: "0.5rem" }}>
                                <BiSearch size={23} />
                            </span>
                            <input
                                type="text"
                                spellCheck="false"
                                onChange={(e) => {
                                    setpageCount(1);
                                    setsearch(e.target.value);
                                }}
                                placeholder="Search users by name.."
                            />
                        </div>
                    </div>
                    <div className={s["title"]}>
                        <button
                            onClick={() => !isExportingLoading && exportTransactionFunc()}
                            disabled={isExportingLoading}
                            style={{
                                padding: "8px 16px",
                                backgroundColor: isExportingLoading ? "var(--clr-theme)" : "var(--clr-theme)",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                cursor: isExportingLoading ? "not-allowed" : "pointer",
                                fontWeight: "bold",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        > 
                            {isExportingLoading ? (
                                <div className="loader_small">
                                    <FaSpinner className="spin" />
                                    Exporting...
                                </div>
                            ) : (
                                "Export to Excel"
                            )}
                        </button>
                    </div>
                </div>
            </div>
            <div className="">
                <div className={s["date_input_box"]}>
                    <input
                        type="date"
                        value={startDate}
                        onChange={(e) => setstartDate(e.target.value)}
                    />
                    <input
                        type="date"
                        value={endDate}
                        onChange={(e) => setendDate(e.target.value)}
                    />
                    <select onChange={(e) => setstatusFilter(e.target.value)}>
                        <option value="">Select Status filter</option>
                        <option value="pending">pending</option>
                        <option value="success">success</option>
                        <option value="failed">failed</option>
                    </select>
                </div>
                {/* <div className={s["mock_test_dropdown"]}></div>
          <div className={s["mock_test_dropdown"]}></div> */}
            </div>
            <div className="beat_table" style={{ overflowX: "auto" }}>
                <Table sx={{ minWidth: 700, maxWidth: "100%" }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            {/* <StyledTableCell align="center">Image</StyledTableCell> */}
                            <StyledTableCell align="center">Transaction ID</StyledTableCell>
                            <StyledTableCell align="center">
                                Transaction Timing
                            </StyledTableCell>
                            <StyledTableCell align="center">Order Id</StyledTableCell>
                            <StyledTableCell align="center">User Name</StyledTableCell>
                            <StyledTableCell align="center">Contact Number</StyledTableCell>
                            <StyledTableCell align="center">Puja Id</StyledTableCell>
                            <StyledTableCell align="center" style={{ minWidth: "300px" }}>
                                Puja Name
                            </StyledTableCell>
                            <StyledTableCell align="center" style={{ minWidth: "120px" }}>
                                Puja Date
                            </StyledTableCell>
                            <StyledTableCell align="center">Gotra</StyledTableCell>
                            <StyledTableCell align="center">Primary God Name</StyledTableCell>
                            <StyledTableCell align="center">Purpose</StyledTableCell>
                            <StyledTableCell align="center">Amount</StyledTableCell>
                            <StyledTableCell align="center">Status</StyledTableCell>
                            <StyledTableCell align="center">Upload Certificate</StyledTableCell>
                            <StyledTableCell align="center">Upload Video</StyledTableCell>
                            <StyledTableCell align="center">Details</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {adminTransactions?.map((row) => (
                            <StyledTableRow key={row.id}>
                                {/* <StyledTableCell>
                                    {row?.item?.thumbImage ? <img style={{ height: "2rem", width: "3rem" }} src={getBaseUrl2() + row?.item?.thumbImage} alt="" /> : null}
                                </StyledTableCell> */}
                                <StyledTableCell align="center">
                                    {row?.paymentId || "--------"}{" "}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    <div>
                                        <p>{row?.created_at?.slice(0, 10)}</p>
                                        <p>{new Date(row?.created_at).toLocaleTimeString()}</p>
                                    </div>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    {row?.orderId}{" "}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    {row?.user_info?.name || "----------------"}{" "}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    {row?.userId?.phone}{" "}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    {row?.eventId?._id}{" "}
                                </StyledTableCell>
                                <StyledTableCell align="center" style={{ width: "300px" }}>
                                    {row?.eventId?.name}{" "}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    {row?.eventId?.date.slice(0, 10)}{" "}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    {row?.user_info?.gotra || "--------"}{" "}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    {row?.eventId?.primaryGodName || "--------"}{" "}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    {row?.eventId?.purpose || "----------"}{" "}
                                </StyledTableCell>
                                <StyledTableCell align="center">{row?.amount} </StyledTableCell>
                                <StyledTableCell align="center">
                                    <div
                                        style={{ cursor: "pointer" }}
                                        // onClick={() => banner_status(bankDetail)}
                                        className={`${row.status === "pending"
                                            ? s.pending_admin
                                            : row.status === "failed"
                                                ? s.inactive_admin
                                                : s.active_admin
                                            }`}
                                    >
                                        {row?.status}
                                    </div>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    <div
                                        className={s["title"]}
                                        onClick={() => {
                                            settransactionId(row._id);
                                            setuserId(row?.userId?._id);
                                            setuploadVideoModal(true);
                                            setTypeForPopUp("certificate");
                                        }}
                                    >
                                        Certificate
                                    </div>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    <div
                                        className={s["title"]}
                                        onClick={() => {
                                            settransactionId(row._id);
                                            setuserId(row?.userId?._id);
                                            setuploadVideoModal(true);
                                            setTypeForPopUp("video");
                                        }}
                                    >
                                        UPLOAD
                                    </div>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    <div
                                        className={s["title"]}
                                        onClick={() => {
                                            navigate(`/view-new-transaction`, {
                                                state: {
                                                    pagetype: "Edit",
                                                    data: row,
                                                },
                                            });
                                        }}
                                    >
                                        View Details
                                    </div>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
                {adminTransactions?.length <= 0 && <DataNotFound />}
            </div>
            {adminTransactions?.length > 0 && (
                <TablePaginationDemo
                    totalData={totalData}
                    rowOnAPage={limit}
                    setLimit={setLimit}
                    pageNo={pageCount}
                    setpageCount={setpageCount}
                />
            )}
            {adminTransactions?.length > 0 && (
                <div className={s["pagination"]}>
                    <Pagination
                        count={pageLength}
                        size="large"
                        style={{ color: "#D21903" }}
                        onChange={(e, value) => setpageCount(value)}
                        page={pageCount}
                    />
                </div>
            )}
            <Dialog
                open={deletePopup}
                aria-labelledby="form-dialog-title"
                maxWidth="xs"
                fullWidth="true"
                onClose={() => setdeletePopup(false)}
            >
                <DialogTitle className={s.dialog_title}>
                    <div>Do you want to delete {currentTransaction.category_name}?</div>
                </DialogTitle>
                <DialogContent className={s.cardpopup_content}>
                    <div style={{ display: "flex", gap: "1rem" }}>
                        <div
                            className={s.employee_gl_popup}
                            onClick={() => setdeletePopup(false)}
                        >
                            Cancel
                        </div>
                        <div className={s.employee_gl_popup_del}>Delete</div>
                    </div>
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>
            <Loder loading={isLoading} />
            <UploadNewTransactionVideoUrl
                open={uploadVideoModal}
                setOpen={setuploadVideoModal}
                transactionId={transactionId}
                typeForPopUp={typeForPopUp}
            />
        </div>
    );
};

export default NewTransactionList;

